import { useState } from 'react'
import type { Media } from '@nhanho/shared'
import { Button } from '../ui/Button'
import { MediaPicker } from './MediaPicker'

/** Chọn MỘT ảnh (ảnh đại diện bài viết, ảnh SEO, ảnh danh mục…). */
export function ImageField({ value, onChange, label = 'Chọn ảnh' }: { value: Media | null; onChange: (m: Media | null) => void; label?: string }) {
  const [open, setOpen] = useState(false)
  return (
    <div className="flex items-center gap-3">
      <div className="size-20 shrink-0 overflow-hidden rounded-image border border-border bg-sand">
        {value && <img src={value.sizes?.thumbnail?.url ?? value.url} alt={value.alt} className="size-full object-cover" />}
      </div>
      <div className="flex flex-col gap-1.5">
        <Button variant="secondary" size="sm" onClick={() => setOpen(true)}>{value ? 'Đổi ảnh' : label}</Button>
        {value && <Button variant="ghost" size="sm" onClick={() => onChange(null)}>Bỏ ảnh</Button>}
      </div>
      <MediaPicker open={open} onClose={() => setOpen(false)} onPick={(d) => onChange(d[0] ?? null)} />
    </div>
  )
}
